import type { SVGProps } from "react";

export function IconBlueShield(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 21.5L15.8564 19.3575C19.0311 17.5938 21 14.2476 21 10.616V3H12H3V10.616C3 14.2476 4.96892 17.5938 8.14357 19.3575L12 21.5Z"
        fill="#5486FA"
        stroke="#5486FA"
        strokeWidth="1.5"
      />
    </svg>
  );
}
